import { EChatOperationActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Состояние процесса операции
 */
export const setChatOperationPending = actionGenerator<EChatOperationActionTypes.SetPending, boolean>(
  EChatOperationActionTypes.SetPending,
);

/**
 * Добавить чат в архив
 */
export const addChatToArchive = actionGenerator<EChatOperationActionTypes.AddToArchive, string>(
  EChatOperationActionTypes.AddToArchive,
);

/**
 * Убрать чат из архива
 */
export const removeChatFromArchive = actionGenerator<EChatOperationActionTypes.RemoveFromArchive, string>(
  EChatOperationActionTypes.RemoveFromArchive,
);

/**
 * Добавить чат в спам
 */
export const addChatToSpam = actionGenerator<EChatOperationActionTypes.AddToSpam, string>(
  EChatOperationActionTypes.AddToSpam,
);

/**
 * Убрать чат из спама
 */
export const removeChatFromSpam = actionGenerator<EChatOperationActionTypes.RemoveFromSpam, string>(
  EChatOperationActionTypes.RemoveFromSpam,
);
